import { getRgObjectsOfType as g, RG_TYPE as a } from "@project-rouge/rg-core";
import { getVerticalWallArea as c } from "../total-metrics/index59.js";
import { getBuildingChildrenAtLevel as f } from "../../../utils/rg-util/index.js";
const u = (r, l, i) => {
  const e = g(r, a.Building);
  if (e.length <= 0)
    return 0;
  let t = 0;
  for (const n of e) {
    const o = f(n, l, i);
    t += c(o);
  }
  return t;
};
export {
  u as getLevelVerticalWallArea
};
//# sourceMappingURL=index35.js.map
